// @flow

import type { JSONValue, Locale } from 'common/types';
import { oneOf } from 'common/json/extract';

export const locale: JSONValue => Locale = oneOf([
  'fi',
  'sv',
  'en',
  'da',
  'pl',
  'es'
]);
